import React, { useEffect, useState } from "react";
import { Avatar } from "@material-ui/core";
import {
  AddAPhoto,
  Call,
  GifRounded,
  InsertEmoticon,
  Mic,
  VideocamRounded,
} from "@material-ui/icons";
import "./Chat.css";
import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";
import { selectChatId, selectChatName } from "../features/chatSlice";
import db from "../firebase";
import Message from "./Message";
import FlipMove from "react-flip-move";
import firebase from "firebase";
// import * as timeago from "timeago.js";

function Chat() {
  const [seed, setSeed] = useState("");
  const user = useSelector(selectUser);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const chatName = useSelector(selectChatName);
  const chatId = useSelector(selectChatId);

  useEffect(() => {
    setSeed(Math.floor(Math.random() * 5000));
  }, []);

  useEffect(() => {
    if (chatId) {
      db.collection("chats")
        .doc(chatId)
        .collection("messages")
        .orderBy("timestamp", "desc")
        .onSnapshot((snapshot) =>
          setMessages(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          )
        );
    }
  }, [chatId]);

  const sendMessage = (e) => {
    e.preventDefault();
    console.log(input);
    db.collection("chats").doc(chatId).collection("messages").add({
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      message: input,
      uid: user.uid,
      photo: user.photo,
      email: user.email,
      displayName: user.displayName,
    });
    setInput("");
  };
  return (
    <div className="chat">
      <div className="chat__header">
        <div className="chat__headerLeft">
          <Avatar
            src={`https://avatars.dicebear.com/api/avataaars/${seed}.svg`}
          />
          <div className="chat__headerInfo">
            <h3>{chatName}</h3>
            {/* <p>{`Last Seen ${timeago.format(
              new Date(messages[0]?.timestamp?.toDate())
            )}`}</p> */}
          </div>
        </div>

        <div className="chat__headerRight">
          <Call />
          <VideocamRounded />
        </div>
      </div>
      <div className="chat__message">
        <FlipMove>
          {messages.map(({ id, data }) => (
            <Message key={id} contents={data} />
          ))}
        </FlipMove>
      </div>
      <div className="chat__footer">
        <InsertEmoticon />
        <AddAPhoto />
        <GifRounded fontSize="large" />

        <form>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type a message"
          />
          <button type="submit" onClick={sendMessage}>
            Send a message
          </button>
        </form>
        <Mic />
      </div>
    </div>
  );
}

export default Chat;
